import React from "react";
import { Link } from "react-router-dom";
import "./adminDashboard.css";

function previewText(text, max = 72) {
  const s = String(text || "").replace(/\s+/g, " ").trim();
  if (s.length <= max) return s;
  return `${s.slice(0, max).trim()}…`;
}

export default function DashboardMessagesCard({ items, loading }) {
  const list = items || [];

  return (
    <div className="adminCard">
      <div className="adminCardHeader">
        <h3 className="adminCardTitle">Messages</h3>
        <Link to="/admin/messages" className="adminButton">
          View all
        </Link>
      </div>
      <div className="adminCardBody adminDashPreviewBody">
        {loading ? (
          <div className="adminList">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="adminDashPreviewRow" aria-hidden="true">
                <div className="adminSkeleton" style={{ width: "45%", height: 12 }} />
                <div className="adminSkeleton" style={{ width: "80%", marginTop: 8, height: 10 }} />
              </div>
            ))}
          </div>
        ) : list.length === 0 ? (
          <div className="adminEmpty adminDashPreviewEmpty">No messages yet.</div>
        ) : (
          <div className="adminList">
            {list.map((m) => (
              <div key={m.id} className="adminDashPreviewRow">
                <div className="adminDashPreviewTop">
                  <span className="adminDashPreviewName">{m.name}</span>
                  <span className="adminDashPreviewDate">{m._displayDate}</span>
                </div>
                <div className="adminDashPreviewEmail">{m.email}</div>
                <div className="adminDashPreviewSnippet">{previewText(m.message)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
